import produce from 'immer';
import * as types from 'actions/search-all/types';

const categoryInitialShape = {
  isOnLazyLoad: false,
  content: [],
  page: 0,
  isAllItemsWereLoaded: false,
  error: null,
};

const initialState = {
  query: null,
  isLoading: null,
  categories: {},
};

export default produce((draft, action) => {
  switch (action.type) {
    case types.FETCH:
      draft.query = action.payload.query;
      draft.isLoading = true;
      break;
    case types.FETCH_SUCCESS: {
      const { payload } = action;

      payload.forEach(({ id, content }) => {
        draft.categories[id] = { ...categoryInitialShape, content };
      });
      draft.isLoading = false;
      break;
    }
    case types.FETCH_ERROR: {
      draft.isLoading = false;
      break;
    }
    case types.LOAD_EXTRA_ITEMS: {
      const { id } = action.payload;
      draft.categories[id].isOnLazyLoad = true;
      break;
    }
    case types.LOAD_EXTRA_ITEMS_SUCCESS: {
      const { id, content, page, isAllItemsWereLoaded } = action.payload;

      draft.categories[id].content = draft.categories[id].content.concat(content);
      draft.categories[id].page = page;
      draft.categories[id].isOnLazyLoad = false;
      draft.categories[id].isAllItemsWereLoaded = isAllItemsWereLoaded;
      break;
    }
    case types.LOAD_EXTRA_ITEMS_ERROR: {
      const { id, error } = action.payload;
      draft.categories[id].isOnLazyLoad = false;
      draft.categories[id].error = error;
      break;
    }
    case types.RESET_SERACH_DATA:
      return { ...initialState };
    default:
    // nothing
  }
}, initialState);
